export const ITEM_TAX_APPLICABLE_FIELD = 'isTaxApplicable'
export const ITEM_TAX_INCLUSIVE_FIELD = 'isTaxInclusive'
export const ITEM_AUTO_GENERATE_SKU_FIELD = 'shouldAutoGenerateSku'
